import { Country, countries, countryIds } from "@mindlercare/schema";
import { useCallback, useState } from "react";
import { Flag } from "../flag";
import { Typography } from "../typography";
import {
  SelectedItemWrapper,
  StyledArrowDown,
  StyledDropdownItem,
  StyledDropdownOuter,
  StyledDropdownWrapper,
  StyledWrapper,
} from "./marketSelector.styles";
import { MarketSelectorProps } from "./marketSelector.types";

export const MarketSelector = ({
  currentMarket,
  canSelectMarket,
  handleMarketSelect,
  allowSwitchRegions = false,
}: MarketSelectorProps) => {
  const [selectedMarket, setSelectedMarket] = useState(
    countries[currentMarket],
  );
  const availableMarkets = Object.values(countries).filter(({ countryId }) => {
    // Since switching regions assumes switching backend, current implementation
    // that might use this component hasn't been modified to support this feature.
    return allowSwitchRegions ? true : countryId !== countryIds.SE;
  });
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDropdown = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const handleOnMarketSelect = (market: Country) => {
    setIsOpen(false);
    setSelectedMarket(market);
    handleMarketSelect(market);
  };

  return (
    <StyledWrapper>
      <SelectedItemWrapper
        $canSelectMarket={canSelectMarket}
        onClick={() => {
          if (canSelectMarket) {
            handleOpenDropdown();
          }
        }}
      >
        <Flag market={selectedMarket.codeISO2} size="Large" />
        <Typography variant="body-small">{selectedMarket.name}</Typography>
        {canSelectMarket && <StyledArrowDown />}
      </SelectedItemWrapper>
      {isOpen && (
        <StyledDropdownOuter>
          <StyledDropdownWrapper>
            {availableMarkets?.map((market) => (
              <StyledDropdownItem
                $canSelectMarket={canSelectMarket}
                $selected={market.countryId === selectedMarket.countryId}
                key={market.countryId}
                onClick={() => handleOnMarketSelect(market)}
              >
                <Typography variant="body-small">{market?.name}</Typography>
              </StyledDropdownItem>
            ))}
          </StyledDropdownWrapper>
        </StyledDropdownOuter>
      )}
    </StyledWrapper>
  );
};
